import { createBrowserRouter, type RouteObject } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { ErrorPage } from 'src/components/ErrorPage';
import { LeaderboardView } from 'src/views/LeaderboardView';

const leaderboardRoutes: Array<RouteObject> = [
  {
    path: '/leaderboard/:eventSlug',
    element: <LeaderboardView />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/leaderboard',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(leaderboardRoutes);

export const LeaderboardRouter = () => {
  return <RouterProvider router={router} />;
};
